exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-078b1382]{padding:30px;-webkit-box-sizing:border-box;box-sizing:border-box;height:calc(100% - 64px)}.box .contaner[data-v-078b1382]{background-color:#fff;margin-top:30px;-webkit-box-shadow:0 3px 5px #d9dde3;box-shadow:0 3px 5px #d9dde3;padding:15px}.box .contaner ul li[data-v-078b1382]{padding-left:30px;height:50px;line-height:50px;border-bottom:1px solid #eee;position:relative}.box .contaner ul .unread[data-v-078b1382] :after{content:\"\";width:6px;height:6px;background-color:red;position:absolute;left:12px;top:22px;border-radius:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-078b1382","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/view/HomePage/Message.vue
// module id = JruP
// module chunks = 1